<template>
    <div class="container-bar">
        <v-chart :options="option"  autoresize/>
    </div>
</template>
<script>
import ECharts from 'vue-echarts'

import 'echarts/lib/chart/bar'

import 'echarts/lib/component/legend'

export default {
  name: 'barChart',
  props: {  
    rotate:{
      type:String,
      default:()=>"0"
    },
    data:{
       type:Object,
       default:()=>{
         return {
           y: ['南京', '杭州', '苏州', '北京', '大连', '天津', '山东'],
           value: [
                {data:[120, 132, 101, 134, 90, 230, 210]},
               {data:[320, 302, 301, 334, 390, 330, 320]}
           ]
         }
       }
     }
  },
  data () {  
    return {     
       option:{}
    }
  },
  methods: {
 
  },
  mounted () {
   
    this.option = {
  
        legend: {
          textStyle:{                           
             color: '#ffffff'//字体颜色
            },
            left: '6%',
            top:"30px",
              itemWidth: 8,
            itemHeight: 8,
            data: ['活跃会员', '非活跃会员']
        },
        grid: {
            
            left: '3%',
            right: '4%',
            bottom: '3%',
            containLabel: true
        },
        xAxis: {
             axisLabel: {             
                color:'#FFFFFF',
                rotate:this.rotate,
             },
            axisTick:{show:false},
            type: 'category',
            data: this.data.y
        },
        yAxis: {
           axisLabel: {
             
                color:'#FFFFFF',
                 formatter : function (value)
                    {
                        let valueTxt = '';
                        if (value.length > 3) {
                            valueTxt = value.substring(0, 4) ;
                        }
                        else {
                            valueTxt = value;
                        }
                        return valueTxt+"%" ;
                    }
            },
          type: 'value',
             splitLine:{ show:false},
             
        },
       
        series: [
           {
                name: '非活跃会员',
                type: 'bar',
                stack: '总量',              
                data:this.data.value[0].data,
                itemStyle:{
								  	normal:{color:'#6648FF'}
                  },
                   barGap: '0%'
            }  ,
            {
                name: '活跃会员',
                type: 'bar',
                stack: '总量',              
                data: this.data.value[1].data,
                 itemStyle:{
								  	normal:{color:'#377DFF'}
                  },
                   barGap: '0%'

            },
                
        ]
    };
  },
  components: {
      'v-chart': ECharts
  }  
}
</script>

<style lang="scss">

        .container-bar{
           height: 100%;
            width: 100%;
        .echarts{
            width: 100%;
            height: 100%;
        }
    }
</style>